//@ts-expect-error untyped
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { fromJS, OrderedMap } from 'immutable';
const formatCommunicationSubscriptionRecord = subscription => {
  return new ReferenceRecord({
    description: subscription.description,
    id: `${subscription.id}`,
    label: subscription.name,
    referencedObject: fromJS(subscription)
  });
};
const formatCommunicationSubscriptions = response => response.reduce((acc, subscription) => {
  return acc.set(String(subscription.id), formatCommunicationSubscriptionRecord(subscription));
}, OrderedMap());
export default formatCommunicationSubscriptions;